import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=0474aed3&scoped=true&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ChangePassword.vue?vue&type=style&index=1&id=0474aed3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0474aed3",
  null
  
)

export default component.exports